import { createReducer, on } from '@ngrx/store';
import { UserContextActions } from './user-context.actions';
import { UserContextState, initialUserContextState } from './user-context.state';

export const userContextReducer = createReducer(
  initialUserContextState,
  on(UserContextActions.loadContext, (state): UserContextState => ({
    ...state,
    status: 'loading',
    error: null,
  })),
  on(UserContextActions.loadContextSuccess, (_state, { context }): UserContextState => ({
    context,
    status: 'loaded',
    error: null,
  })),
  on(UserContextActions.loadContextFailure, (state, { error }): UserContextState => ({
    ...state,
    status: 'error',
    error,
  })),
);
